import { render, staticRenderFns } from "./CollectionConfirmation.vue?vue&type=template&id=0670d2a2&scoped=true"
import script from "./CollectionConfirmation.vue?vue&type=script&lang=ts"
export * from "./CollectionConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670d2a2",
  null
  
)

export default component.exports